/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { SubTitle, Image, Description, DivRelative, Link } from '../../components/layouts';
import './style.scss';
import { Grid } from 'semantic-ui-react';
import { pureTrans } from '../../helpers';
import { IMAGES } from './resource';

function BlockTitle1() {
  return (
    <>
      <SubTitle>
        儿童运动人像
        <br />
        孩子拍照总爱动？
        <br />
        没关系
      </SubTitle>
      <Description>聪明的AI智能检测算法可以精准检测到儿童，记录天生好动的小朋友。</Description>
    </>
  );
}

function BlockTitle2() {
  return (
    <>
      <SubTitle>记录成长 “美” 一刻</SubTitle>
      <Description>
        儿童专属运动人像模式，即刻拍摄美美的儿童照，留念每一刻。
        <Link bordered={false} href="https://shop.vivo.com.cn/product/10006160" text="购买我的X60 Pro" position={10} />
      </Description>
    </>
  );
}

export default function DesktopContent({ progress }) {
  const { c1, c2, d1, d2, e1, e2, f1, f2, g1, g2, h1, h2 } = useMemo(
    () => ({
      // pic left
      c1: pureTrans(progress, [0.1, 0.3], [0.05, 1], 3),
      c2: pureTrans(progress, [0.1, 0.3, 0.6], [0, -10, -30], 3),

      // text right
      d1: pureTrans(progress, [0.1, 0.3], [0.05, 1], 3),
      d2: pureTrans(progress, [0.1, 0.3, 0.6], [0, -50, -80], 3),

      // pic right
      e1: pureTrans(progress, [0.2, 0.4], [0.05, 1], 3),
      e2: pureTrans(progress, [0.2, 0.4, 0.6], [0, -30, -80], 3),

      // text left 2
      f1: pureTrans(progress, [0.3, 0.55], [0.05, 1], 3),
      f2: pureTrans(progress, [0.3, 0.55, 0.8], [-80, -100, -100], 3),

      // pic right 2
      g1: pureTrans(progress, [0.4, 0.6], [0.1, 1], 3),
      g2: pureTrans(progress, [0.4, 0.65, 0.9], [0, -50, -100], 3),

      // pic left 2
      h1: pureTrans(progress, [0.5, 0.65], [0.05, 1], 3),
      h2: pureTrans(progress, [0.5, 0.7, 0.9], [-40, -60, -80], 3)
    }),
    [progress]
  );
  return (
    <>
      <Grid columns={2} className="section-content section-6-block-2">
        <Grid.Column className="s6-b2-left">
          <DivRelative opacity={c1} transform={`translateY(${c2}%)`}>
            <Image paddingBottom="133.28%" src={IMAGES[1]} className="section-6-image-2" />
            <Description className="small">AI智能检测到儿童，启动运动抓拍算法。</Description>
          </DivRelative>
        </Grid.Column>
        <Grid.Column className="s6-b2-right">
          <DivRelative opacity={d1} transform={`translateY(${d2}%)`}>
            <BlockTitle1 />
          </DivRelative>
          <DivRelative opacity={e1} transform={`translateY(${e2}%)`}>
            <Image paddingBottom="134.50%" src={IMAGES[2]} className="section-6-image-3" />
          </DivRelative>
        </Grid.Column>
      </Grid>

      <Grid columns={2} className="section-content section-6-block-3">
        <Grid.Column className="s6-b3-left">
          <DivRelative opacity={f1} transform={`translateY(${f2}%)`}>
            <BlockTitle2 />
          </DivRelative>
          <DivRelative opacity={h1} transform={`translateY(${h2}%)`}>
            <Image paddingBottom="134.41%" src={IMAGES[3]} className="section-6-image-4" />
          </DivRelative>
        </Grid.Column>
        <Grid.Column className="s6-b3-right">
          <DivRelative opacity={g1} transform={`translateY(${g2}%)`}>
            <Image paddingBottom="132.88%" src={IMAGES[4]} className="section-6-image-5" />
          </DivRelative>
        </Grid.Column>
      </Grid>
    </>
  );
}
